module.exports = __webpack_public_path__ + "img/oufu_72x95x12b.prt.eb7c9c3b.jpg";